import { AccountBalanceDto } from 'src/dtos';
import { AccountBalance } from 'src/models';

export const mapAccountBalanceDtoToModel = (dto: AccountBalanceDto): AccountBalance => ({
  ...dto,
  cashAvailable: Number(
    (dto.availableFunds - dto.pendingOfferOrdersTotal + dto.pendingExternalOfferOrdersTotal).toFixed(2),
  ),
});
